/**
 * Shared constants for the package permission check feature.
 */

/** Link to the FLC User Guide permissions guidance documentation. */
export const FUG_PERMISSIONS_URL =
  'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-using-flc.html#flc-build-permissions';

/** Link to the FLC User Guide "Conference Branch Management" guidance. */
export const CONFERENCE_BRANCH_MANAGEMENT_URL =
  'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-writing-content.html#flc-branching-strategy';

/** Hash route to the Active Packages page. */
export const ACTIVE_PACKAGES_ROUTE = '#/active-packages';
